import Rendering3D from "./components/Rendering3D";

export default Rendering3D